import type React from 'react';
import { SkeletonPage, Layout, Card, SkeletonBodyText, BlockStack, SkeletonDisplayText, Box } from '@shopify/polaris';

/**
 * 设置页面骨架屏组件
 */
const SettingSkeleton: React.FC = () => {
  return (
    <SkeletonPage primaryAction>
      <Layout>
        <Layout.Section variant='oneThird'>
          <Box padding='400'>
            <SkeletonBodyText />
          </Box>
        </Layout.Section>
        <Layout.Section>
          <Card>
            <BlockStack gap='400'>
              <SkeletonDisplayText size="medium" />
              <SkeletonBodyText />
              <SkeletonBodyText />
              <SkeletonBodyText />
            </BlockStack>
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
};

export default SettingSkeleton; 